<template>
  <button
    :type="type"
    :disabled="disabled"
    :class="[
      'hab-button',
      {
        [`${className}`]: className,
        [`theme-${theme}`]: theme,
        [`min-${min}`]: min,
        [`color-${color}`]: color,
        [`shape-${shape}`]: shape,
      },
    ]"
    v-on:click="onClick"
  >
    <div v-if="loading" class="loading"><span class="loader"></span></div>
    <span class="name">{{ label }}</span>
    <slot name="rightElement"></slot>
  </button>
</template>

<script>
export default {
  props: {
    className: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "button",
    },
    label: {
      type: String,
      default: "",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    theme: {
      type: [String, Number],
      default: null,
    },
    min: {
      type: [String, Number],
      default: null,
    },
    color: {
      type: String,
      default: "",
    },
    shape: {
      type: String,
      default: "",
    },
  },
  emits: ["onClick"],
  methods: {
    onClick() {
      return this.$emit("onClick");
    },
  },
};
</script>
